import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/packagesSalesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const PeriodType = () => {
  const dispatch = useDispatch();

  const periodTypeOptions = useSelector((state) => state.packagesSales.periodTypeOptions);
  const selectedPeriodTypes = useSelector(
    (state) => state.packagesSales.selectedFilters.period_type
  );

  return (
    <MultiSelectDropdown
      options={periodTypeOptions}
      selectedFilters={selectedPeriodTypes}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updatePeriodType(data))}
    />
  );
};

export default PeriodType;
